<app-navbar></app-navbar>

<div class="breadcrumb">
    <a href="/">YouPrice</a>  &rarr; 
    <strong>Contacter YouPrice</strong>
</div>


<section class="contact-section">
  <div class="contact-header">
    <h2 class="section-title">
      <span class="desktop-only">Contacter <span class="text-blue">YouPrice</span></span>
      <span class="mobile-only">Contact</span>
    </h2>
    <p class="section-subtitle">
      Une question sur votre forfait ou besoin d'assistance ?<br>
      Notre équipe est là pour vous répondre par différents canaux.
    </p>
  </div>

  <div class="contact-cards-container">
    <div class="contact-card">
      <div class="icon-wrapper">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="64" rx="32" fill="#164B80"/>
<path d="M32 43.25V40.75H40.75V23.25H32V20.75H40.75C41.4375 20.75 42.026 20.9948 42.5156 21.4844C43.0052 21.974 43.25 22.5625 43.25 23.25V40.75C43.25 41.4375 43.0052 42.026 42.5156 42.5156C42.026 43.0052 41.4375 43.25 40.75 43.25H32ZM29.5 38.25L27.7812 36.4375L30.9688 33.25H20.75V30.75H30.9688L27.7812 27.5625L29.5 25.75L35.75 32L29.5 38.25Z" fill="white"/>
</svg>
      </div>
      <h3>Depuis votre Espace Client</h3>
      <p class="card-text">Accédez à la rubrique Assistance pour poser toutes vos questions et obtenir un support personnalisé lié à votre contrat.</p>
      <p class="card-schedule bold-schedule">Horaire: 7j/7 de 9h à 20h</p>
      <a href="https://espace-client.youprice.fr/connexion-espace-client" class="card-link">Se connecter &rarr;</a>
    </div>

    <div class="contact-card">
      <div class="icon-wrapper">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="64" rx="32" fill="#164B80"/>
<path d="M22 42C21.3125 42 20.724 41.7552 20.2344 41.2656C19.7448 40.776 19.5 40.1875 19.5 39.5V24.5C19.5 23.8125 19.7448 23.224 20.2344 22.7344C20.724 22.2448 21.3125 22 22 22H42C42.6875 22 43.276 22.2448 43.7656 22.7344C44.2552 23.224 44.5 23.8125 44.5 24.5V39.5C44.5 40.1875 44.2552 40.776 43.7656 41.2656C43.276 41.7552 42.6875 42 42 42H22ZM32 33.25L22 27V39.5H42V27L32 33.25ZM32 30.75L42 24.5H22L32 30.75ZM22 27V24.5V27V39.5V27Z" fill="white"/>
</svg>

      </div>
      <h3>Par voie postale</h3>
      <p class="card-schedule">7j/7 de 9h à 20h</p>
      <p class="card-text mb-0">Service Client YouPrice.<br>189 rue Solférino, 59000 – Lille</p>
    </div>

    <div class="contact-card">
      <div class="icon-wrapper">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="64" rx="32" fill="#164B80"/>
<path d="M32 44.5C30.2708 44.5 28.6458 44.1719 27.125 43.5156C25.6042 42.8594 24.2812 41.9688 23.1562 40.8438C22.0312 39.7188 21.1406 38.3958 20.4844 36.875C19.8281 35.3542 19.5 33.7292 19.5 32C19.5 30.2708 19.8281 28.6458 20.4844 27.125C21.1406 25.6042 22.0312 24.2812 23.1562 23.1562C24.2812 22.0312 25.6042 21.1406 27.125 20.4844C28.6458 19.8281 30.2708 19.5 32 19.5C33.7292 19.5 35.3542 19.8281 36.875 20.4844C38.3958 21.1406 39.7188 22.0312 40.8438 23.1562C41.9688 24.2812 42.8594 25.6042 43.5156 27.125C44.1719 28.6458 44.5 30.2708 44.5 32V33.8125C44.5 35.0417 44.0781 36.0885 43.2344 36.9531C42.3906 37.8177 41.3542 38.25 40.125 38.25C39.3958 38.25 38.7083 38.0938 38.0625 37.7812C37.4167 37.4688 36.875 37.0208 36.4375 36.4375C35.8333 37.0417 35.151 37.4948 34.3906 37.7969C33.6302 38.099 32.8333 38.25 32 38.25C30.2708 38.25 28.7969 37.6406 27.5781 36.4219C26.3594 35.2031 25.75 33.7292 25.75 32C25.75 30.2708 26.3594 28.7969 27.5781 27.5781C28.7969 26.3594 30.2708 25.75 32 25.75C33.7292 25.75 35.2031 26.3594 36.4219 27.5781C37.6406 28.7969 38.25 30.2708 38.25 32V33.8125C38.25 34.3542 38.4271 34.8125 38.7812 35.1875C39.1354 35.5625 39.5833 35.75 40.125 35.75C40.6667 35.75 41.1146 35.5625 41.4688 35.1875C41.8229 34.8125 42 34.3542 42 33.8125V32C42 29.2083 41.0312 26.8438 39.0938 24.9062C37.1562 22.9688 34.7917 22 32 22C29.2083 22 26.8438 22.9688 24.9062 24.9062C22.9688 26.8438 22 29.2083 22 32C22 34.7917 22.9688 37.1562 24.9062 39.0938C26.8438 41.0312 29.2083 42 32 42H38.25V44.5H32ZM32 35.75C33.0417 35.75 33.9271 35.3854 34.6562 34.6562C35.3854 33.9271 35.75 33.0417 35.75 32C35.75 30.9583 35.3854 30.0729 34.6562 29.3438C33.9271 28.6146 33.0417 28.25 32 28.25C30.9583 28.25 30.0729 28.6146 29.3438 29.3438C28.6146 30.0729 28.25 30.9583 28.25 32C28.25 33.0417 28.6146 33.9271 29.3438 34.6562C30.0729 35.3854 30.9583 35.75 32 35.75Z" fill="white"/>
</svg>

      </div>
      <h3>Par e-mail</h3>
      <p class="card-schedule text-muted">Du lundi au vendredi de 9h à 18h</p>
      <p class="card-text">Munissez-vous de votre numéro de contrat et posez vos questions à notre service client à l'adresse :</p>
      <div class="badge-solid">support&#64;youprice.fr</div>
    </div>
  </div>

  <div class="faq-banner">
    <div class="faq-content">
      <div class="icon-wrapper small-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="24" fill="#164B80"/>
<path d="M24 30C24.35 30 24.6458 29.8792 24.8875 29.6375C25.1292 29.3958 25.25 29.1 25.25 28.75C25.25 28.4 25.1292 28.1042 24.8875 27.8625C24.6458 27.6208 24.35 27.5 24 27.5C23.65 27.5 23.3542 27.6208 23.1125 27.8625C22.8708 28.1042 22.75 28.4 22.75 28.75C22.75 29.1 22.8708 29.3958 23.1125 29.6375C23.3542 29.8792 23.65 30 24 30ZM23.1 26.15H24.95C24.95 25.55 25.0167 25.1083 25.15 24.825C25.2833 24.5417 25.5667 24.1833 26 23.75C26.5833 23.1667 26.9958 22.6792 27.2375 22.2875C27.4792 21.8958 27.6 21.45 27.6 20.95C27.6 20.0667 27.3 19.3542 26.7 18.8125C26.1 18.2708 25.2917 18 24.275 18C23.3583 18 22.5792 18.225 21.9375 18.675C21.2958 19.125 20.85 19.75 20.6 20.55L22.25 21.2C22.3667 20.75 22.6 20.3875 22.95 20.1125C23.3 19.8375 23.7083 19.7 24.175 19.7C24.625 19.7 25 19.8208 25.3 20.0625C25.6 20.3042 25.75 20.625 25.75 21.025C25.75 21.3083 25.6583 21.6083 25.475 21.925C25.2917 22.2417 24.9833 22.5917 24.55 22.975C24 23.4583 23.6208 23.9208 23.4125 24.3625C23.2042 24.8042 23.1 25.4 23.1 26.15ZM17 33C16.45 33 15.9792 32.8042 15.5875 32.4125C15.1958 32.0208 15 31.55 15 31V17C15 16.45 15.1958 15.9792 15.5875 15.5875C15.9792 15.1958 16.45 15 17 15H31C31.55 15 32.0208 15.1958 32.4125 15.5875C32.8042 15.9792 33 16.45 33 17V31C33 31.55 32.8042 32.0208 32.4125 32.4125C32.0208 32.8042 31.55 33 31 33H17ZM17 31H31V17H17V31ZM17 17V31V17Z" fill="white"/>
</svg>

      </div>
      <div class="faq-text-container">
        <h4>Besoin d'aide immédiate ?</h4>
        <p>Consultez notre FAQ complète pour trouver des réponses instantanées.</p>
      </div>
    </div>
    <button class="btn-solid" (click)="goToFaq()">Consulter la FAQ</button>
  </div>
</section>





<app-always-there></app-always-there>
<app-small-faq></app-small-faq>
<app-interest-you></app-interest-you>
<app-footer></app-footer>